import { render } from "./EventParticipate.vue?vue&type=template&id=60d2d3b8"
import script from "./EventParticipate.vue?vue&type=script&lang=js"
export * from "./EventParticipate.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.posnania.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__